import { useEffect, useRef } from 'react';
import { CountryCodes } from '../Helper/constants';

// On desktop the card floats bottom-right; lift it above the copyright band once that band scrolls into view.
function useLiftAboveFooter(ref) {
    useEffect(() => {
        let frame = null;
        const update = () => {
            frame = null;
            const cta = ref.current;
            const band = document.querySelector('.tiny-footer');
            if(!cta) {
                return;
            }
            const lift = band ? Math.max(0, window.innerHeight - band.getBoundingClientRect().top) : 0;
            cta.style.setProperty('--cta-lift', lift + 'px');
        };
        const schedule = () => {
            if(frame === null) {
                frame = window.requestAnimationFrame(update);
            }
        };
        update();
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule);
        return () => {
            window.removeEventListener('scroll', schedule);
            window.removeEventListener('resize', schedule);
            if(frame !== null) {
                window.cancelAnimationFrame(frame);
            }
        };
    }, [ref]);
}

function ClinicCTAButtons(props) {
    const ref = useRef(null);
    useLiftAboveFooter(ref);
    const has_mobile = props.clinic.contact.mobile.length > 0;
    if(has_mobile) {
        let contact_no = props.clinic.contact.mobile[0];
        let url = "https://wa.me/" + CountryCodes.india.replace('+', '') + contact_no;
        let call_url = "tel:" + CountryCodes.india + contact_no;
        return (<div className="sticky-cta" ref={ref}>
            <div className="sticky-cta__inner">
                <a href={url} target="_blank" rel="noopener noreferrer" className="sticky-btn sticky-btn--secondary cta-whatsapp" aria-label="Chat on WhatsApp">
                    <span className="sticky-btn__icon"><i className="fa-brands fa-whatsapp"></i></span>
                    <span className="sticky-btn__label">WhatsApp</span>
                </a>
                <a href={call_url} className="sticky-btn sticky-btn--secondary cta-call" aria-label="Call the clinic">
                    <span className="sticky-btn__icon"><i className="fa-solid fa-phone"></i></span>
                    <span className="sticky-btn__label">Call</span>
                </a>
                <a href="/appointment" className="sticky-btn sticky-btn--primary cta-appointment" aria-label="Book an appointment">
                    <span className="sticky-btn__icon"><i className="fa-regular fa-calendar-check"></i></span>
                    <span className="sticky-btn__text-long">Book Appointment</span>
                    <span className="sticky-btn__text-short">Book Now</span>
                    <i className="fa-solid fa-arrow-right sticky-btn__arrow"></i>
                </a>
            </div>
        </div>)
    }
    return (<></>);
  }
  
  export default ClinicCTAButtons;
